// Lets Puppeteer (see PDFOps.CreatePDF) know when a report has actually
// finished loading data, instead of relying on network-idle timing which
// can fire before slower widgets (tables, charts, pivots) clear their
// loading/skeleton state.

const LOADING_SELECTORS = ".loading, .cd-table-skeleton, .cd-table-search-skeleton, .chart-loading, .loader-loading";

export function startReportReadinessWatch(maxWaitMs = 20000, quietMs = 300) {
    (<any>window).reportReady = false;

    let quietTimer: ReturnType<typeof setTimeout> | null = null;
    let maxTimer: ReturnType<typeof setTimeout> | null = null;

    const finish = () => {
        if (quietTimer) clearTimeout(quietTimer);
        if (maxTimer) clearTimeout(maxTimer);
        observer.disconnect();
        (<any>window).reportReady = true;
    };

    const checkQuiet = () => {
        if (quietTimer) clearTimeout(quietTimer);
        if (document.querySelectorAll(LOADING_SELECTORS).length === 0) {
            quietTimer = setTimeout(finish, quietMs);
        }
    };

    const observer = new MutationObserver(checkQuiet);
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["class"] });

    // Fallback so a widget stuck loading forever can't hang the PDF export.
    maxTimer = setTimeout(finish, maxWaitMs);

    checkQuiet();
}
